const pdfTableWidth = 190;
const pdfPageSize = 100;
const pdfDownloadTimeFormat = 'DD/MM/YYYY';

const pdfTableMargin = { top: 10, right: 10, bottom: 20, left: 10 };

const pdfHeadStyles = {
  fillColor: [255, 255, 255],
  fontStyle: 'bold',
  textColor: [0, 0, 0],
};

function modifyPdfTableStyle(data, doc) {
  if (data.section === 'head') {
    doc.setDrawColor(0, 0, 0, 0.2);
    doc.setLineWidth(0.3);
    doc.line(
      data.cell.x,
      data.cell.y,
      data.cell.x + data.cell.width,
      data.cell.y
    );
    doc.line(
      data.cell.x,
      data.cell.y + data.cell.height,
      data.cell.x + data.cell.width,
      data.cell.y + data.cell.height
    );
  }
}
function adjustColumnStyles(headers) {
  return headers.reduce((result, header, index) => {
    const fractionWidth = parseFloat(header.width) / 100;
    return { ...result, [index]: { cellWidth: fractionWidth * 190 } };
  }, {});
}

function adjustPdfTableHeader(headers, label = 'name') {
  return headers.map((header) => {
    return header[label];
  });
}

const pdfConfig = {
  startY: 35,
  margin: pdfTableMargin,
  theme: 'striped',
  headStyles: pdfHeadStyles,
  pageBreak: 'auto',
};

export {
  pdfTableWidth,
  pdfPageSize,
  pdfConfig,
  modifyPdfTableStyle,
  pdfDownloadTimeFormat,
  adjustColumnStyles,
  adjustPdfTableHeader,
};
